export function InterceptorsService($cookies, APIEndpoint) {
    'ngInject';

    const interceptors = {
        request(config) {
            const token = $cookies.get('authToken');

            // Add token
            // and API endpoint to request
            if (config.url.indexOf('http') === -1 && config.url.indexOf('api') > 0) {
                if (token) {
                    config.headers['Auth-Token'] = token;
                }
                config.url = `${APIEndpoint}${config.url}`;
            }

            return config;
        }
    };

    return interceptors;

}




// WEBPACK FOOTER //
// ./client/app/core/core.interceptors.js